export function getCookie(key: string): string | undefined {
  let cookie = "";

  try {
    cookie = document.cookie.replace(/[ ]/g, "");
  } catch (error) {
    if (typeof console !== "undefined" && console.error) {
      console.error("[GatCollect] read cookie error:", error);
    }

    return undefined;
  }

  const cookieItems = cookie.split(";");

  for (let i = 0; i < cookieItems.length; i++) {
    const item = cookieItems[i].split("=");

    if (key === item[0]) {
      return item[1];
    }
  }

  return undefined;
}
